import IMWarehouseForm from './IMWarehouseForm';
export default IMWarehouseForm;
